__turbopack_context__.v({
  "logos": "styles-module-scss-module__mlCOka__logos",
  "logos__affiliate": "styles-module-scss-module__mlCOka__logos__affiliate",
  "logos__affiliate__mod247Wallst": "styles-module-scss-module__mlCOka__logos__affiliate__mod247Wallst",
  "logos__affiliate__modFortune": "styles-module-scss-module__mlCOka__logos__affiliate__modFortune",
  "logos__affiliate_image": "styles-module-scss-module__mlCOka__logos__affiliate_image",
  "logos__affiliate_image__modInvert": "styles-module-scss-module__mlCOka__logos__affiliate_image__modInvert",
  "logos__divider": "styles-module-scss-module__mlCOka__logos__divider",
});
